import { GET_PROVIDER, GET_PROVIDER_ERROR, GET_PROVIDER_SUCCESS } from './ProviderSection.actions'

const providerSectionState = {
  amount: 0,
  amountUSD: 0,
  biddings: undefined,
  dni: undefined,
  error: undefined,
  loading: true,
  link: '#',
  name: '',
  ranking: 1,
  year: undefined
}

/**
 * The provider section's reducer.
 */
const providerSectionReducer = (state = providerSectionState, { payload, type }) => {
  switch (type) {
    case GET_PROVIDER: {
      return { ...state, loading: true }
    }
    case GET_PROVIDER_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDER_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default providerSectionReducer
